<span *ngIf="!isButton" class="text-primary d-flex align-items-end text-capitalize">
    <img src="assets/images/rank_icon.svg" alt="rank icon" aria-hidden="true" />&nbsp;
    {{ 'YOUR_RANK' | translate }} {{ rank ? '#' + rank : '&nbsp;-'}}
</span>
<div *ngIf="isButton" class="rank-btn w-100">
    <div role="button" tabindex="0" aria-label="show rank leaderboard" class="d-flex cursor-pointer justify-content-between align-items-center" (click)="btnClick()">
        <span class="text-primary d-flex align-items-end text-capitalize">
            <img src="assets/images/rank_icon.svg" alt="rank icon" aria-hidden="true" />&nbsp;
            {{ 'YOUR_RANK' | translate }} {{ rank ? '#' + rank : '&nbsp;-'}}
        </span>
        <i class="text-primary fa-solid fa-chevron-right" aria-hidden="true"></i>
    </div>
</div>
